export class NameIdDescModel {
  public id: number;
  public name: string;
  public description: string;
}
